import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { TableRowActionsMenu, TableRowActionsMenuItem } from '@occc/ui-design-system';

import { routeCreator } from '../../../scan-data.router';

type RJRActionsContainerProps = {
  id: string;
};

export const RJRActionsContainer = ({ id }: RJRActionsContainerProps) => {
  const navigate = useNavigate();

  const menuItems = useMemo(() => {
    const items: TableRowActionsMenuItem[] = [
      {
        label: 'View Group Detail',
        onClick: () => navigate(routeCreator.submissionGroupsDetails(id)),
        dataTestId: 'view-submission-group-details',
      },
    ];

    return items;
  }, [navigate, id]);

  return <TableRowActionsMenu menuItems={menuItems} />;
};
